import { inject, Injectable, signal } from '@angular/core';
import { ContactRequest } from '@interfaces';
import { FuncService } from '../../../../services';

@Injectable({
	providedIn: 'root'
})
export class ContactRequestService {

	private func = inject(FuncService);
	public readonly contactRequestDetails = signal<ContactRequest | undefined>(undefined);

	public async getContactRequestById(contactRequestId: number): Promise<void> {
		const res = await this.func.contactRequest.getContactRequestById({ contactRequestId });
		if (res) {
			this.contactRequestDetails.set(res);
		}
	}

	public async updateClosedContactRequest(closed: boolean, contactRequestId: number): Promise<void> {
		const res = await this.func.contactRequest.updateClosedContactRequest({ closed, contactRequestId });
		if (res) {
			const currentDetails = this.contactRequestDetails();
			this.contactRequestDetails.set({
				...currentDetails!,
				closed
			});
		}
	}

	public async addEngagementIdToContactRequest(contactRequestId: number, engagementId: number): Promise<void> {
		await this.func.contactRequest.addEngagementId({ contactRequestId, engagementId });
		const currentDetails = this.contactRequestDetails();
		this.contactRequestDetails.set({
			...currentDetails!,
			engagementId: engagementId
		});
	}
}